import axios from '@axios'

export class FilterServices{
    static async  getFilterOptionsBy(col_name) {
     
        return new Promise((resolve, reject) => {
          axios.get('filters/getFilterBy', { params: {type:col_name,categories:['LANDFILL_AREA'],} })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      }

}

